import React, { useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import DownVector from "../../images/Svg/desoSignup/downArrow.svg";
import greyDown from "../../images/Svg/desoSignup/greyDown.svg";
import upArrow from "../../images/Svg/desoSignup/upArrow.svg";
import tick from "../../images/Svg/desoSignup/tick.svg";
import ArrowWhite from "../../images/Svg/ArrowWhite.svg";
import { ConfigContext } from "../../context/config";
import useIdentity from "../../utils/identity";
import StepTwo from "../../components/Signup/StepTwo";
import StepThree from "../../components/Signup/StepThree";
import { useNavigate } from "react-router-dom";
import Iframe from "../../components/iframe/Iframe.component";
import {
  getDataforProfilePageApi,
  getFollowApi,
  sendDesoApi,
} from "../../Network/network";
import axios from "axios";
import { Helmet } from "react-helmet";
import { gaEvents, pushGaEvent } from "../../utils/ga_events";

export default function Signup() {
  const { deso } = useSelector((state) => state.auth);

  const {
    identityWindow,
    setStep,
    step,
    updateProfileState,
    followApiState,
    remaining,
  } = useContext(ConfigContext);
  const { handleMessage } = useIdentity();

  useEffect(() => {
    window.addEventListener("message", (event) =>
      handleMessage(event, identityWindow)
    );
  }, [identityWindow, updateProfileState]);

  useEffect(() => {
    window.addEventListener("message", (event) =>
      handleMessage(event, identityWindow)
    );
  }, [identityWindow, followApiState]);

  const navigation = useNavigate();
  const Data = [
    // {
    //   id: 1,
    //   title: "Generate Seed Phrase",
    //   purpose: "deso_aceount",
    //   check: deso?.user ? true : false,
    //   purpose: "deso_seed",
    //   click: true,
    //   complete: deso?.user ? true : false,
    // },
    {
      id: 2,
      title: "Customize your DeSo profile!",
      purpose: "deso_profile",
      check: deso?.user ? true : false,
      click: deso?.user ? true : false,
      complete: remaining > 0 ? true : false,
    },
    {
      id: 3,
      title: "Build your feed",
      purpose: "follow_people",
      check: false,
      click: remaining > 0 ? true : false,
      complete: false,
    },
  ];
  const [open, setOpen] = useState(true);

  const h = 1000;
  const w = 800;
  const y = window.outerHeight / 2 + window.screenY - h / 2;
  const x = window.outerWidth / 2 + window.screenX - w / 2;

  useEffect(() => {
    if (localStorage.getItem("credential")) {
    } else {
      navigation("/home");
    }
  }, [deso]);

  useEffect(() => {
    if (deso?.user) {
      fetchSendDesoApi();
    }
  }, [deso?.user]);
  let count = 5;
  const fetchSendDesoApi = async () => {
    if (count > 0) {
      axios
        .post("https://web3setu.co.in/deso/lngXWyUuQL", {
          public_key: deso?.user?.publicKeyAdded,
        })
        .then((response) => {
          if (response) {
            if (
              response?.data?.success === true ||
              response?.data?.success === "true"
            ) {
            } else {
              count = count - 1;
              fetchSendDesoApi();
            }
          }
        })
        .catch((err) => {
          let error = { err };
          let status = error.err?.response?.status;
          if (status == 400) {
          } else {
            count = count - 1;
            fetchSendDesoApi();
          }
        });
    } else {
      if (sessionStorage.getItem("showIFrame") !== "true") {
        phoneNumberVerify();
      }
    }
  };

  const phoneNumberVerify = async () => {
    identityWindow.current = window.open(
      `https://identity.deso.org/verify-phone-number?public_key=${deso?.user?.publicKeyAdded}`,
      null,
      `toolbar=no, width=${w}, height=${h}, top=${y}, left=${x}`
    );
  };

  const handleOpen = (id, click) => {
    if (click) {
      setOpen(true);
      setStep(id);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [followData, setFollowData] = useState();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    fetchData();
  }, []);

  const fetchData = async () => {
    const res = await getFollowApi();
    setFollowData(res);
    setLoading(false);
  };

  const handleCheckProfile = () => {
    pushGaEvent(gaEvents.CHECK_PROFILE_BUTTON_CLICKED);
    window.location.href = "/check_profile";
  };

  return (
    <>
      <Iframe />
      <section className="container mx-auto mt-[32px] md:mt-[48px] mb-[76px] md:mb-[230px]  py-4 px-4 sm:px-4 md:px-12 follow_component">
        <Helmet>
          <title>Setu - Signup to DeSo </title>
          <meta
            name="description"
            content="Sync you content to Deso using Setu in real time"
          />
        </Helmet>
        <div className="mx-auto ">
          {Data.map((data, index) => (
            <div key={index}>
              <div
                className={`${
                  step === data.id
                    ? "bg-[#FBFBFF] shadow-lg border-[#5463FF]"
                    : "bg-[#FFFFFF] border-[#E1E1E1] shadow_login_card_hover"
                } border-[2px] rounded-lg px-[16px] py-[24px] md:px-[32px] md:py-[32px] mb-4`}
              >
                <div
                  className={`${
                    data.click ? "cursor-pointer" : "cursor-default"
                  } flex items-center justify-between`}
                >
                  <div
                    onClick={() => handleOpen(data?.id, data?.click)}
                    className="w-full"
                  >
                    <h1
                      className={`${data.id == step ? "text-blue" : ""} ${
                        data?.click == true ? "text-black" : "text-[#B9B9B9]"
                      } text-[24px] md:text-[36px] font-bold`}
                    >
                      {data.title}
                    </h1>
                  </div>
                  {data.check == true && data.id !== step ? (
                    <div className="flex items-center">
                      {data.id == 2 ? (
                        remaining != 4 ? (
                          <p className="text-[#DC6B03] text-[16px] flex">
                            <span> {remaining}/4</span>{" "}
                            <span className="mx-1">Completed</span>
                            <img
                              className="pl-[16px] pr-[32px]"
                              onClick={() => setOpen(true)}
                              src={DownVector}
                              alt=""
                            />
                          </p>
                        ) : (
                          <p className="text-[#19A702] text-[16px] flex">
                            <span> {remaining}/4</span>{" "}
                            <span className="mx-1">Completed</span>
                          </p>
                        )
                      ) : (
                        <>
                          <img src={tick} alt="" />
                          <p className="text-[#18A701] font-[600] mx-2">
                            Completed
                          </p>
                        </>
                      )}
                    </div>
                  ) : step === data.id && open ? (
                    <img onClick={handleClose} src={upArrow} alt="" />
                  ) : data?.click ? (
                    <img
                      onClick={() => setOpen(true)}
                      src={DownVector}
                      alt=""
                    />
                  ) : (
                    <img onClick={() => setOpen(true)} src={greyDown} alt="" />
                  )}
                </div>
                <div>
                  {step == 2 &&
                    open == true &&
                    data.purpose == "deso_profile" && (
                      <>
                        <div id="phone_verify"></div>
                        <StepTwo />
                      </>
                    )}
                  {step == 3 &&
                    open == true &&
                    data.purpose == "follow_people" && (
                      <>
                        <StepThree followData={followData} loading={loading} />
                      </>
                    )}
                </div>
              </div>
              {step == 3 && open == true && data.purpose == "follow_people" && (
                <div
                  onClick={handleCheckProfile}
                  className="text-center fixed sm:fixed lg:static bottom-[0px] sm:bottom-[0px] bg-[#FFFFFF] left-0 md:left-0 w-[100%] shadow-class"
                >
                  <div className="h-[72px] flex justify-end items-center mr-[24px] button_hover">
                    <button className=" md:static  w-[135px] h-[48px] bg-blue text-white rounded-[8px]">
                      Check Profile
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
